(function () {
  function boot() {
    var roots = document.querySelectorAll('[data-pdp-reviews]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      if (root.dataset.revInit === '1') return;
      root.dataset.revInit = '1';
      bindWrite(root);
      var pid = root.getAttribute('data-pdp-reviews');
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        var pw = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget && window.jdgm.data.reviewWidget[pid];
        if (pw && pw.reviews && pw.reviews.length) { clearInterval(timer); try { render(root, pw); } catch (e) {} }
        else if (tries > 48) { clearInterval(timer); }
      }, 250);
    });
  }

  function bindWrite(root) {
    var btn = root.querySelector('.ftb-rev-writebtn');
    if (!btn || btn.dataset.jmBound === '1') return;
    btn.dataset.jmBound = '1';
    btn.addEventListener('click', function (e) {
      var jm = document.querySelector('.jm-review-widget button.jm-button--primary, .shopify-section--apps button.jm-button--primary, button.jm-button--primary, .jdgm-write-rev-link');
      if (jm) { e.preventDefault(); jm.click(); return; }
      var href = btn.getAttribute('href');
      if (!href || href === '#') e.preventDefault();
    });
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : ('' + s)); return d.innerHTML; }

  function stars(rating) {
    var r = Math.round(rating || 0), h = '';
    for (var i = 1; i <= 5; i++) h += '<span class="ftb-star' + (i <= r ? ' on' : '') + '">★</span>';
    return h;
  }

  function timeAgo(iso) {
    var t = new Date(iso).getTime();
    if (isNaN(t)) return '';
    var days = Math.floor(Math.max(0, (Date.now() - t) / 86400000));
    if (days < 1) return 'today';
    if (days < 7) return days === 1 ? '1 day ago' : days + ' days ago';
    var w = Math.floor(days / 7);
    if (days < 35) return w === 1 ? '1 week ago' : w + ' weeks ago';
    var mo = Math.floor(days / 30);
    if (days < 365) return mo === 1 ? '1 month ago' : mo + ' months ago';
    var y = Math.floor(days / 365);
    return y === 1 ? '1 year ago' : y + ' years ago';
  }

  function card(r) {
    var name = esc(r.reviewer_name || 'Anonymous');
    var init = esc(((r.reviewer_initial || (r.reviewer_name || '?').charAt(0)) + '').toUpperCase());
    var title = r.title ? '<strong>' + esc(r.title) + '</strong>' : '';
    var body = esc(r.body || '');
    var isShop = (r.source && /shop/i.test(r.source)) || (r.transparency_badges && r.transparency_badges.indexOf('review_written_in_shop_app') !== -1);
    var verified = '';
    if (isShop) verified = '<img class="ftb-rev-shopbadge" src="https://judgeme-public-images.imgix.net/judgeme/verified-badge-v2/verified-by-shop_light.svg" alt="Verified by Shop" width="97" height="20" loading="lazy">';
    else if (r.verified_buyer) verified = '<span class="ftb-rev-verified">✓ Verified Review</span>';
    var ago = timeAgo(r.created_at);
    var foot = ago ? '<div class="ftb-rev-foot"><span class="ftb-rev-time">' + ago + '</span></div>' : '';
    return '<article class="ftb-rev-card">'
      + '<div class="ftb-rev-cardhead"><div class="ftb-rev-avatar">' + init + '</div>'
      + '<div class="ftb-rev-who"><div class="n">' + name + '</div></div>' + verified + '</div>'
      + '<div class="ftb-rev-cardstars"><span class="ftb-stars">' + stars(r.rating) + '</span>' + title + '</div>'
      + (body ? '<p class="ftb-rev-body">' + body + '</p>' : '')
      + foot
      + '</article>';
  }

  function setText(root, sel, txt) { var e = root.querySelector(sel); if (e) e.textContent = txt; }

  function render(root, pw) {
    if (pw.average_rating != null) setText(root, '[data-rev-avg]', parseFloat(pw.average_rating).toFixed(1));
    if (pw.number_of_reviews != null) setText(root, '[data-rev-total]', pw.number_of_reviews);

    var sumStars = root.querySelector('[data-rev-sumstars]');
    if (sumStars && pw.average_rating != null) sumStars.innerHTML = stars(pw.average_rating);

    var histoEl = root.querySelector('[data-rev-histo]');
    if (histoEl && pw.histogram && pw.histogram.length) {
      var max = 1;
      pw.histogram.forEach(function (h) { if ((h.frequency || 0) > max) max = h.frequency; });
      histoEl.innerHTML = pw.histogram.map(function (h) {
        var pct = Math.round((h.frequency || 0) / max * 100);
        return '<div class="ftb-histo-row"><span class="lbl">' + h.rating + '<i>★</i></span>'
          + '<span class="track"><span class="bar" style="width:' + pct + '%;"></span></span>'
          + '<span class="cnt">' + (h.frequency || 0) + '</span></div>';
      }).join('');
    }

    var listEl = root.querySelector('[data-rev-list]');
    if (listEl && pw.reviews && pw.reviews.length) {
      listEl.innerHTML = pw.reviews.map(card).join('');
    }

    root.classList.add('is-live');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
